import { render, staticRenderFns } from "./TablaMovimientosStock.vue?vue&type=template&id=a33e867a&"
import script from "./TablaMovimientosStock.vue?vue&type=script&lang=js&"
export * from "./TablaMovimientosStock.vue?vue&type=script&lang=js&"
import style0 from "./TablaMovimientosStock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
